/**
 * Localized crash boundary for the routed tree. Lives under LocaleProvider so it
 * can pull বাং/EN copy from the dictionary, and forwards caught errors to
 * telemetry. The @dp/ui ErrorBoundary stays locale-agnostic; this wires the copy.
 */
import type { ReactNode } from "react";
import { ErrorBoundary } from "@dp/ui";
import { useT } from "../i18n/LocaleProvider.js";
import { useConfig } from "../config.js";
import { captureException } from "../telemetry.js";

export function AppErrorBoundary({ children }: { children: ReactNode }) {
  const t = useT();
  const config = useConfig();
  return (
    <ErrorBoundary
      title={t.crash.title}
      message={t.crash.body.replace("{support}", config.supportPhone)}
      reloadLabel={t.crash.reload}
      onReload={() => location.reload()}
      onError={(error) => captureException(error, { boundary: "app" })}
    >
      {children}
    </ErrorBoundary>
  );
}
